import {router} from "@inertiajs/vue3";
import FormButtons from "@/pages/components/form-buttons.vue";

export default {
	components: {FormButtons},

	data() {
		return {
			formRoute: '',
			redirectRoute: '',
			loading: false,
			stayOnPage: true
		}
	},

	methods: {
		submit() {
			this.loading = true;
			let form = {};
			if(this.form) {
				form = this.form;
			} else {
				form = this.$refs.form.form;
			}

			$.ajax({
				url: this.formRoute,
				method: this.getFormMethod(),
                contentType: 'application/json',
                processData: false,
				data: JSON.stringify(form.data()),
				// data: form.data(),
				success: this.onSuccess.bind(this, form),
				error: this.onError.bind(this, form),
			}).always(() => {
				this.loading = false;
				this.afterSubmit(form);
			});
		},

		onSuccess(form, response) {
			form.reset('password', 'password_confirmation');
			form.isDirty = false;

			if (!this.stayOnPage) {
				router.get(this.redirectRoute, {
					'success': 'De wijzigingen zijn opgeslagen'
				});
				return;
			}
			if(response.message) {
                Helpers.Message.success(response.message);
			} else {
                Helpers.Message.success('De wijzigingen zijn opgeslagen');
			}

			this.afterSuccess(form, response)
		},

		afterSuccess(form, response) {

		},

		afterSubmit(form) {
			$(document).trigger('customsubmit');
		},

		onError(form, response) {
			Helpers.Form.handleErrors(form, response);
		},

		getSuccessMessage() {
			return 'De wijzigingen zijn opgeslagen';
		},

		getFormMethod() {
			return 'PUT'
		}
	}
}